export const fonts = {
  "source-code": ["Source Code Pro, ", "monospace"],
  poppins: ["Poppins, ", "sans-serif"],
};